var hasDuplicates = require("../duplicates/index");
var isValidEmail = function isValidEmail(email) {
  var _email$match;
  if (email === void 0) {
    email = '';
  }
  var regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var regExpDomain = /[^\@][a-zA-Z0-9$&+,;=?#|'<>.^*()%!-]+$/ig;
  var domain = (_email$match = email.match(regExpDomain)) !== null && _email$match !== void 0 ? _email$match : "";
  if (domain.toString().length > 0 && hasDuplicates(domain.toString().split("."))) {
    return false;
  }
  if (email.indexOf('@-') > 0) {
    return false;
  }
  return regExp.test(email);
};
module.exports = isValidEmail;